var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAccounts = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_account",
    transform: "translate(-18 -87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 22,
    height: 22,
    transform: "translate(18 87)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "moving_ministry_FILL0_wght300_GRAD-25_opsz20",
    d: "M71.218-778.076a.783.783,0,0,1-.559-.223.721.721,0,0,1-.234-.543v-14.464a.735.735,0,0,1,.23-.545.765.765,0,0,1,.556-.225H81.636a.773.773,0,0,1,.554.225.729.729,0,0,1,.234.545v14.464a.726.726,0,0,1-.23.543.764.764,0,0,1-.551.223h-3.89v-4.241H75.1v4.241Zm.454-1.222h2.177v-4.241H79v4.241h2.177v-13.556H71.672Zm2.177-6.375h1.487v-1.457H73.849Zm0-3.591h1.487v-1.457H73.849Zm3.664,3.591H79v-1.457H77.514Zm0-3.591H79v-1.457H77.514ZM73.849-779.3v-4.241H79v0H73.849Z",
    transform: "translate(-47.425 884.076)",
    fill: "#8d8d8d"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAccounts, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/accounts.658b7e9a.svg";
export { ForwardRef as ReactComponent };